import React from 'react';

import DynamicPageContainer from '@/components/DynamicPages/DynamicPageContainer';

import { PortfolioParagraphProps } from '@/helpers/getComponentForDynamicPage';
import { getParagraphForDynamicPage } from '@/helpers/getParagraphForDynamicPage';

import { ContentBlock } from '@/types/types';

interface SectionProps {
  blocks: ContentBlock[];
  sectionId?: string;
  number?: React.ReactElement<SVGElement>;
  order?: number;
}

export const DynamicSection: React.FC<SectionProps> = ({ blocks, sectionId, number, order }) => {
  const isGraySection = order !== undefined && order % 2 === 0;
  const noPaddingBottom = blocks?.some((item) => item.strapi_component === 'blog-blocks.cta');
  const paragraphs = blocks?.map((item) =>
    getParagraphForDynamicPage(item as PortfolioParagraphProps, isGraySection as boolean),
  );

  return (
    <DynamicPageContainer id={sectionId} number={number} noPaddingBottom={noPaddingBottom}>
      {paragraphs}
    </DynamicPageContainer>
  );
};
